import * as yup from 'yup'
import { checkFlightNoExists } from '../../../lib/queries'

export const flightSchema = yup.object().shape({
    flightNo: yup
        .string()
        .required('Flight number is required')
        .matches(/^[A-Z]{2}[0-9]{3,4}$/, 'Flight number must be in format: XX123 or XX1234')
        .test('unique-flight-no', 'Flight number already exists',
            async function (value) {
                if (!value) return true // Skip validation if no value
                // Skip validation if we're in edit mode and the flight number hasn't changed
                if (this.options.context?.isEdit) return true

                try {
                    const exists = await checkFlightNoExists(value)
                    return !exists
                } catch (error) {
                    return false
                }
            }
        ),
    departure: yup.mixed()
        .transform((value) => (value && value.value ? value.value : value))
        .required('Departure airport is required'),
    arrival: yup.mixed()
        .transform((value) => (value && value.value ? value.value : value))
        .required('Arrival airport is required')
        .test('different-airports', 'Departure and arrival airports cannot be the same',
            function (value) {
                return this.parent.departure !== value
            }
        ),
    airlineLogo: yup
        .string()
        .required('Airline logo URL is required')
        .url('Please enter a valid URL for the airline logo'),
}) 